import Cookies from 'js-cookie';
import { axios } from '~/clients';
import clientId from '~/constants/clientId';
import { AVAILABILITY } from '~/constants/endpoints';
import type { AvailabilityVehicle, Result, Vehicle } from '~/contracts';

const formatVehicleForRequest = ({
  locationId,
  vehicleId,
  vehicleInventoryType,
  isPurchasePending
}: Vehicle) => {
  const vehicleSaleStatus = isPurchasePending ? null : 'Available';

  return {
    vehicleId,
    vehicleInventoryType,
    vehicleLocationId: locationId,
    vehicleSaleStatus
  };
};

export default function fetchAvailability({
  zip,
  userId,
  vehicles,
  searchRequestId,
  controller
}) {
  return axios.post<Result<AvailabilityVehicle[]>>(
    AVAILABILITY,
    {
      userId,
      zipCode: zip,
      vehicles: vehicles.map(formatVehicleForRequest)
    },
    {
      headers: {
        browserCookieId: Cookies.get('BrowserCookieId') ?? '',
        clientId,
        correlationId: searchRequestId
      },
      signal: controller.signal
    }
  );
}
